(() => {
  const stateKey = 'southwoodCollectionReturn';
  const storagePrefix = 'southwood_collection_return_v2:';
  const maxAge = 4 * 60 * 60 * 1000;
  let departure = null;
  let cancelRestore = () => {};

  if ('scrollRestoration' in history) history.scrollRestoration = 'auto';

  function pageKey() {
    const url = new URL(location.href);
    ['preview_theme_id', '_pjax', '_', 'section_id'].forEach(key => url.searchParams.delete(key));
    url.searchParams.sort();
    return url.pathname + url.search;
  }

  function isCollection() {
    return /^\/collections\//.test(location.pathname) && !location.pathname.includes('/products/');
  }

  function cardFor(link) {
    return link.closest('.pr_grid_item') || link.closest('.product') || link;
  }

  function save(link) {
    if (!isCollection()) return;
    const saved = { key: pageKey(), x: scrollX, y: scrollY, time: Date.now() };
    if (link) {
      saved.product = new URL(link.href, location.href).pathname;
      saved.top = cardFor(link).getBoundingClientRect().top;
    }
    try {
      history.replaceState(Object.assign({}, history.state, { [stateKey]: saved }), '', location.href);
    } catch (error) {}
    try {
      sessionStorage.setItem(storagePrefix + saved.key, JSON.stringify(saved));
    } catch (error) {}
    return saved;
  }

  function readSaved() {
    let saved = history.state && history.state[stateKey];
    if (!saved || saved.key !== pageKey()) {
      try {
        saved = JSON.parse(sessionStorage.getItem(storagePrefix + pageKey()));
      } catch (error) { return null; }
    }
    if (!saved || saved.key !== pageKey() || !Number.isFinite(saved.y) || saved.y < 0 || !saved.time || Date.now() - saved.time > maxAge) return null;
    return saved;
  }

  function isHistoryReturn(event) {
    if (event && (event.persisted || event.type === 'popstate')) return true;
    const entry = history.state && history.state[stateKey];
    if (entry && entry.key === pageKey() && entry.product) return true;
    const navigation = typeof performance.getEntriesByType === 'function' && performance.getEntriesByType('navigation')[0];
    return Boolean((navigation && navigation.type === 'back_forward') || (performance.navigation && performance.navigation.type === 2));
  }

  function restore(event) {
    cancelRestore();
    departure = null;
    if (!isCollection() || !isHistoryReturn(event)) return;
    const saved = readSaved();
    if (!saved) return;
    let stopped = false;
    let observer;
    const timers = [];
    const inputs = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    function stop() {
      stopped = true;
      timers.forEach(clearTimeout);
      if (observer) observer.disconnect();
      inputs.forEach(name => window.removeEventListener(name, stop, true));
    }
    cancelRestore = stop;
    inputs.forEach(name => window.addEventListener(name, stop, { capture: true, passive: true }));
    function align() {
      if (stopped) return;
      if (pageKey() !== saved.key) { stop(); return; }
      let target = saved.y;
      if (saved.product && Number.isFinite(saved.top)) {
        const link = Array.from(document.querySelectorAll('.nt_products_holder a[href*="/products/"]')).find(item => new URL(item.href, location.href).pathname === saved.product);
        if (link) target = scrollY + cardFor(link).getBoundingClientRect().top - saved.top;
      }
      target = Math.max(0, Math.min(target, document.documentElement.scrollHeight - innerHeight));
      if (Math.abs(scrollY - target) > 3) window.scrollTo({ left: saved.x || 0, top: target, behavior: 'instant' });
    }
    align();
    [100, 250, 500, 1000, 2000, 4000].forEach(delay => timers.push(setTimeout(align, delay)));
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(align);
      observer.observe(document.getElementById('nt_content') || document.body);
    }
    timers.push(setTimeout(stop, 4500));
  }

  document.addEventListener('click', event => {
    if (!isCollection() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!link || link.target === '_blank' || link.hasAttribute('download') || new URL(link.href, location.href).origin !== location.origin) return;
    cancelRestore();
    departure = save(link);
  }, true);
  window.addEventListener('pagehide', () => {
    cancelRestore();
    if (!departure || departure.key !== pageKey()) save();
  });
  window.addEventListener('pageshow', restore);
  window.addEventListener('popstate', restore);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, { once: true });
  else restore();
})();
